import { configs } from "../config";
import { callApi } from "./axiosClient";

const cma = "cma";
const articles = "articles";
const categories = "article-categories";
const leads = "leads";
const siteSettings = "site-settings";
const landingFeatures = "landing-features";
const landingMetrics = "landing-metrics";
const landingTestimonials = "landing-testimonials";
const landingFaq = "landing-faq";

const cmaApi = {
  // Articles
  async getArticles(page: number, page_size: number, search?: string) {
    const url = `${cma}/${articles}?page=${page}&page_size=${page_size}${
      search ? `&search=${encodeURIComponent(search)}` : ""
    }`;
    return callApi("GET", url);
  },
  async getArticleDetails(id: string | undefined) {
    const url = `${cma}/${articles}/${id}`;
    return callApi("GET", url);
  },
  async addArticle(data: any) {
    const url = `${cma}/${articles}`;
    return callApi("POST", url, data, configs);
  },
  async editArticle({ id, data }: { id: string | undefined; data: any }) {
    const url = `${cma}/${articles}/${id}`;
    return callApi("PUT", url, data, configs);
  },
  async deleteArticle(id: string) {
    const url = `${cma}/${articles}/${id}`;
    return callApi("DELETE", url);
  },

  // Article categories
  async getCategories() {
    const url = `${cma}/${categories}`;
    return callApi("GET", url);
  },
  async getCategoryDetails(id: string | undefined) {
    const url = `${cma}/${categories}/${id}`;
    return callApi("GET", url);
  },
  async addCategory(data: any) {
    const url = `${cma}/${categories}`;
    return callApi("POST", url, data);
  },
  async editCategory({ id, data }: { id: string | undefined; data: any }) {
    const url = `${cma}/${categories}/${id}`;
    return callApi("PUT", url, data);
  },
  async deleteCategory(id: string) {
    const url = `${cma}/${categories}/${id}`;
    return callApi("DELETE", url);
  },

  // Leads
  async getLeads(
    page: number,
    page_size: number,
    email?: string,
    name?: string,
    phone?: string,
    trangthai?: number
  ) {
    const url = `${cma}/${leads}?page=${page}&page_size=${page_size}${
      email ? `&email=${encodeURIComponent(email)}` : ""
    }${name ? `&name=${encodeURIComponent(name)}` : ""}${
      phone ? `&phone=${encodeURIComponent(phone)}` : ""
    }${trangthai ? `&trangthai=${trangthai}` : ""}`;
    return callApi("GET", url);
  },
  async getLeadDetails(id: string | undefined) {
    const url = `${cma}/${leads}/${id}`;
    return callApi("GET", url);
  },
  async updateLead({
    id,
    data,
  }: {
    id: string | undefined;
    data: { trangthai?: number; note?: string };
  }) {
    const url = `${cma}/${leads}/${id}`;
    return callApi("POST", url, data);
  },
  async deleteLead(id: string) {
    const url = `${cma}/${leads}/${id}`;
    return callApi("DELETE", url);
  },

  // Site settings
  async getSiteSettings() {
    const url = `${cma}/${siteSettings}`;
    return callApi("GET", url);
  },
  async editSiteSettings(data: any) {
    const url = `${cma}/${siteSettings}`;
    return callApi("PUT", url, data);
  },

  // Landing features
  async getLandingFeatures() {
    const url = `${cma}/${landingFeatures}`;
    return callApi("GET", url);
  },
  async getLandingFeatureDetails(id: string | undefined) {
    const url = `${cma}/${landingFeatures}/${id}`;
    return callApi("GET", url);
  },
  async addLandingFeature(data: any) {
    const url = `${cma}/${landingFeatures}`;
    return callApi("POST", url, data);
  },
  async editLandingFeature({
    id,
    data,
  }: {
    id: string | undefined;
    data: any;
  }) {
    const url = `${cma}/${landingFeatures}/${id}`;
    return callApi("PUT", url, data);
  },
  async deleteLandingFeature(id: string) {
    const url = `${cma}/${landingFeatures}/${id}`;
    return callApi("DELETE", url);
  },

  // Landing metrics
  async getLandingMetrics() {
    const url = `${cma}/${landingMetrics}`;
    return callApi("GET", url);
  },
  async getLandingMetricDetails(id: string | undefined) {
    const url = `${cma}/${landingMetrics}/${id}`;
    return callApi("GET", url);
  },
  async addLandingMetric(data: any) {
    const url = `${cma}/${landingMetrics}`;
    return callApi("POST", url, data);
  },
  async editLandingMetric({ id, data }: { id: string | undefined; data: any }) {
    const url = `${cma}/${landingMetrics}/${id}`;
    return callApi("PUT", url, data);
  },
  async deleteLandingMetric(id: string) {
    const url = `${cma}/${landingMetrics}/${id}`;
    return callApi("DELETE", url);
  },

  // Landing testimonials
  async getLandingTestimonials() {
    const url = `${cma}/${landingTestimonials}`;
    return callApi("GET", url);
  },
  async getLandingTestimonialDetails(id: string | undefined) {
    const url = `${cma}/${landingTestimonials}/${id}`;
    return callApi("GET", url);
  },
  async addLandingTestimonial(data: any) {
    const url = `${cma}/${landingTestimonials}`;
    return callApi("POST", url, data);
  },
  async editLandingTestimonial({
    id,
    data,
  }: {
    id: string | undefined;
    data: any;
  }) {
    const url = `${cma}/${landingTestimonials}/${id}`;
    return callApi("PUT", url, data);
  },
  async deleteLandingTestimonial(id: string) {
    const url = `${cma}/${landingTestimonials}/${id}`;
    return callApi("DELETE", url);
  },

  // Landing FAQ
  async getLandingFaq() {
    const url = `${cma}/${landingFaq}`;
    return callApi("GET", url);
  },
  async getLandingFaqDetails(id: string | undefined) {
    const url = `${cma}/${landingFaq}/${id}`;
    return callApi("GET", url);
  },
  async addLandingFaq(data: any) {
    const url = `${cma}/${landingFaq}`;
    return callApi("POST", url, data);
  },
  async editLandingFaq({ id, data }: { id: string | undefined; data: any }) {
    const url = `${cma}/${landingFaq}/${id}`;
    return callApi("PUT", url, data);
  },
  async deleteLandingFaq(id: string) {
    const url = `${cma}/${landingFaq}/${id}`;
    return callApi("DELETE", url);
  },
};

export default cmaApi;
